import type { SmriqWorkItem } from '../types/smriq.types';

// smr-service fills an id for every work item, synthesising `synthetic:<hash>` for the id-less
// core rows (SmriqVisitService::syntheticItemId). Those cannot be echoed back to the vendor.
const SYNTHETIC_ID_PREFIX = 'synthetic:';

/** Only a real vendor id can be echoed back as an exclusion, so only those rows are
 *  re-includable; synthetic-id rows are display-only, and `can_decline` does not apply. */
export const isReincludableDeclinedItem = (item: SmriqWorkItem): boolean =>
    !item.id.startsWith(SYNTHETIC_ID_PREFIX);
